import PropTypes from 'prop-types';
import { TrendPill } from 'src/components/actionCards';

// Period-over-period delta indicator — now a thin alias of the shared TrendPill so tables
// and KPI cards show the same pill: green = good, AMBER = bad (never red), grey "—" = flat
// or unknown. `value` is the percentage change from computeDelta() (null = no comparable
// previous value); `inverted` flips good/bad for cost-type metrics (cost, CPC, FTA).
export default function DeltaChip({ value, inverted }) {
    return <TrendPill value={value} inverted={inverted} />;
}

DeltaChip.propTypes = {
    value: PropTypes.number,
    inverted: PropTypes.bool,
};

DeltaChip.defaultProps = {
    value: null,
    inverted: false,
};
